<template>
	<EditConfiguration
		:widget="widget"
		v-on="$listeners"
		:editMode="editMode"
		v-if="hasConfiguration"
		ref="edit_configuration"
		:configurationId="configurationId"
		:isGeneralConfiguration="isGeneralConfiguration"
	/>
	<div v-else class="no-configuration-message flex-centerize width-100 py-9 mt-9 text-align-center flex-column">
		There are no blocks in {{ isGeneralConfiguration ? 'general' : 'personal' }} setup<br />It will not be visible to users<br />
		<AnemicButton class="mt-6 create-configuration-button" :loading="loading" @click="createConfiguration">
			Create Configuration
		</AnemicButton>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import EditConfiguration from '../EditConfiguration';
import { createConfigurationForSelectedWorkflow } from '@/store/modules/selectedWorkflow/modules/configurations/actions';

export default {
	name: 'EditConfigurationMenu',
	components: { EditConfiguration },
	props: {
		widget: { type: Object },
		editMode: { type: Boolean },
		isGeneralConfiguration: { type: Boolean },
		configurationId: { type: [String, Number] },
	},
	computed: {
		hasConfiguration() {
			return !!this.configurationId;
		},
	},
	methods: {
		focusOnInterface() {
			this.$refs['edit_configuration'] && this.$refs['edit_configuration'].focusOnInterface();
		},
		async addNewBlock() {
			// Triggered from parent
			if (!this.hasConfiguration) {
				await this.createConfiguration();
			}
			this.$nextTick(() => {
				this.$refs.edit_configuration.addNewBlock();
			});
		},
		...mapActions([createConfigurationForSelectedWorkflow.fullPath]),
		async createConfiguration() {
			this.loading = true;
			try {
				await this[createConfigurationForSelectedWorkflow.fullPath]({ isGeneralConfiguration: this.isGeneralConfiguration });
			} catch (error) {
				console.error('error while creating configuration', error);
			} finally {
				this.loading = false;
			}
		},
	},
	data() {
		return {
			loading: false,
		};
	},
};
</script>
<style scoped lang="scss">
.no-configuration-message {
	font-size: 14px;
	color: #757575;
	letter-spacing: 0px;
}
.create-configuration-button {
	height: 40px;
	width: 200px;
	padding: 0px !important;
	font-size: 14px !important;
	background: var(--bg-color) !important;
	color: var(--bold-border-color) !important;
	border: 1px solid var(--bold-border-color) !important;
}
</style>
